const globalScripts = () => {};

export { globalScripts as g };
//# sourceMappingURL=app-globals-DQuL1Twl.js.map

//# sourceMappingURL=app-globals-DQuL1Twl.js.map